export default "__VITE_ASSET__4EpCPV4U__"